export default __webpack_public_path__ + "static/canned-response-ready-to-save-de972056a123c6849e4ec2d829373160.png";